import { put, race, take } from 'redux-saga/effects';

import { selectWhen } from 'store/helpers';
import * as InsuranceCalculationActions from 'store/insuranceCalculation';
import * as InsuranceCalculationConstants from 'store/insuranceCalculation/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageGetApplication = new CreateStage({
  action: InsuranceConstants.ACTIONS.GET_APPLICATION,
  after: function* () {
    const errorSelector = InsuranceCalculationSelectors.selectNestedErrors(
      InsuranceCalculationConstants.ERRORS.FETCH_APPLICATION_DATA
    );

    const [, error] = yield race([
      take(InsuranceCalculationConstants.INSURANCE_CALC_SET_APPLICATION),
      selectWhen(errorSelector, Boolean),
    ]);

    if (error) {
      CreateStage.throwError({ message: error });
    }
  },
  handler: function* () {
    const applicationId = yield selectWhen(InsuranceCalculationSelectors.selectApplicationId);

    yield put(InsuranceCalculationActions.insuranceGetApplicationData({ applicationId }));
  },
  name: InsuranceConstants.STAGES_FIELDS.GET_APPLICATION,
}).watcher;
